<script lang="ts" setup>
import { ref } from 'vue';
import StatementItem  from '@/components/domain/StatementItem.vue'
import type { Statement } from '@/types/domain';
import StatementEvaluation from './StatementEvaluation.vue';
import useModuleStore from '@/stores/moduleStore';
import { useToast } from 'vue-toast-notification';
import { useI18n } from 'vue-i18n'
import type {StatementEvaluationResult } from '@/types/domain'

const { t } = useI18n()

const props = defineProps<{
  statements: Statement[];
}>()

const toast = useToast({ position: 'bottom', queue: true, duration: 1000 });
const moduleStore =  useModuleStore();
const _curStatement = ref<Statement>();
const showEvaluation = ref(false);
const hasNext = ref(true);

let lastEvaluation = ref<number|null|undefined>();
let evaluationCount = 0;
let maxEvaluationCount = props.statements.length;
let index = 0;

function showModal(statementId: string) {
  index = props.statements.findIndex(s => s.id == statementId);
  if (index == -1) {
    return;
  }

  setEvaluationStatement(index);
  showEvaluation.value = true;
}

function setEvaluationStatement(index: number) {
  let statement = props.statements[index];
  lastEvaluation.value = statement.evaluation;
  _curStatement.value = statement;
}

function save(result: StatementEvaluationResult) {
  if(_curStatement.value) {
    if (result.evaluation != null) {
      moduleStore.persistEvaluation(result.statementId,result.evaluation)
      .then(() => {
        toast.success(t('toast.evaluation-saved'))
      });
    }
  }
}

function saveAndClose(result: StatementEvaluationResult) {
  save(result);
  showEvaluation.value = false;
  evaluationCount = 0;
}

function cancel() {
  if(_curStatement.value && lastEvaluation.value != null) {
    _curStatement.value.evaluation = lastEvaluation.value;
  }

  showEvaluation.value = false;
}

function skip() {
  evaluationCount++;
  if (evaluationCount == maxEvaluationCount) {
    showEvaluation.value = false;
    return;
  }

  gotoNext();
}

function saveAndNext(result: StatementEvaluationResult) {
  save(result);
  evaluationCount++;
  if (evaluationCount == maxEvaluationCount) {
    showEvaluation.value = false;
    return;
  }

  if(evaluationCount +1 == maxEvaluationCount) {
    hasNext.value = false;
    return;
  }

  gotoNext();
}

function gotoNext() {
  index++;
  if (index == maxEvaluationCount) {
    index = 0;
  }

  setEvaluationStatement(index);
}

</script>
<template>
  <div class="statement-list">
    <StatementEvaluation v-if="_curStatement && showEvaluation" :statement="_curStatement" @close="cancel" @save="saveAndClose" @save-and-next="saveAndNext" @skip="skip" :has-next="hasNext"></StatementEvaluation>
    <div v-for="(statement) in statements" :key="statement.id">
      <StatementItem :statement=statement @evaluate="showModal"></StatementItem>
    </div>
  </div>
</template>

<style scoped>

</style>
